import React, { useEffect, useRef } from "react";
import useChangeMobileNumberFlow from "../../../hooks/useChangeMobileNumberFlow";
import { ACCOUNT_PASSWORD_PAGE, CHANGE_EMAIL_FLOW, REGISTER_SUCCESS_PAGE, UPDATED_MOBILE_NUMBER_PAGE, VERIFY_OTP_PAGE } from "./data";
import AccountPasswordPage from "./accountPasswordPage";
import ChangeMobileNumberPage from "./changeMobileNumberPage";
import VerifyOtp from "./verifyOtpPage";
import UpdateSucccessPage from "./updateSuccessPage";
import { useDispatch } from "react-redux";
import { resetChangeMobileNumberFlow } from "../../../redux/features/changeMobileNumberSlice";

const ChangeMobileNumberFlow = () => {

  const { currentStep, currentStepIndex } = useChangeMobileNumberFlow();

  // Which way the step enters (index.css, [data-auth-step]): forward on
  // Next, back on Back. Worked out during render so the entrance's first
  // frame already has the right direction.
  const navRef = useRef({ index: currentStepIndex, direction: "forward" });
  if (currentStepIndex !== navRef.current.index) {
    navRef.current = {
      index: currentStepIndex,
      direction: currentStepIndex > navRef.current.index ? "forward" : "back",
    };
  }
  const dispatch = useDispatch();


  useEffect(() => {
    dispatch(resetChangeMobileNumberFlow());
  }, [dispatch]);

  const PageRenderer = () => {
    switch (currentStep?.name) {
      case ACCOUNT_PASSWORD_PAGE:
        return <AccountPasswordPage/>;
      case UPDATED_MOBILE_NUMBER_PAGE:
        return <ChangeMobileNumberPage/>;
      case VERIFY_OTP_PAGE:
        return <VerifyOtp/>;
      case REGISTER_SUCCESS_PAGE:
        return <UpdateSucccessPage/>;
      default:
        return null;
    }
  };
  return (
    <div className="changeMobileNumberModal pt-[0%] pb-[5%] max767:w-full max767:overflow-y-scroll max767:pt-0 max767:pb-[30%] max767:h-screen ipad:pt-[10%] ipad:h-[93vh] ipad:overflow-y-scroll ">
      {/* Keyed by step so each one mounts fresh and plays its entrance. */}
      <div
        key={currentStep?.name}
        data-auth-step
        data-auth-nav={navRef.current.direction}
      >
        {PageRenderer()}
      </div>
    </div>
  );
};

export default ChangeMobileNumberFlow;
